import * as React from 'react';
import { TooltipPanel, APIRequest } from '@reverbdotcom/discovery-ui';
import BulkCuratedSetItem from './bulk_curated_set_item';
import Spinner from '../../../../shared/spinner';

class BulkSaleButton extends React.Component {
  constructor() {
    super();
    this.state = {
      loaded: false,
    };

    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  handleOpen() {
    this.loadCuratedSets();
  }

  handleClose() {
    // we want to reload the data on next open
    this.setState({ loaded: false });
  }

  loadCuratedSets() {
    APIRequest.V3.get(`${CORE_API_HOST}/api/my/listings/curated_sets${window.location.search}`).then((response) => {
      this.setState({
        curatedSets: response.curated_sets,
        loaded: true,
      });
    });
  }

  renderSets() {
    return this.state.curatedSets.map(set =>
      (<BulkCuratedSetItem
        curatedSet={set}
        key={set.id}
      />));
  }

  renderPanel() {
    if (!this.state.loaded) {
      return (
        <Spinner />
      );
    }

    if (this.state.curatedSets.length === 0) {
      return (
        <div className="padding-2 align-center">
          {I18n.t('js.dashboard.selling.bulkSale.noSales')}
          <br />
          <a href="/my/selling/sales">
            {I18n.t('js.dashboard.selling.bulkSale.createASale')}
          </a>
        </div>
      );
    }

    return (
      <div>
        <h4 className="weight-bold align-center mt-half">{I18n.t('js.dashboard.selling.bulkSale.header')}</h4>
        <div className="bulk-sale-list">
          {this.renderSets()}
        </div>
      </div>
    );
  }

  render() {
    return (
      <TooltipPanel
        triggerProps={{
          className: 'button button--small icon-l-tag icon-r-caret-down',
          children: I18n.t('js.dashboard.selling.bulkSale.sale'),
        }}
        align="left"
        className="tooltip-panel--medium"
        onOpen={this.handleOpen}
        onClose={this.handleClose}
      >
        {this.renderPanel()}
      </TooltipPanel>
    );
  }
}

export default BulkSaleButton;



// WEBPACK FOOTER //
// ./javascripts/components/dashboard/selling/listings_manager/sales/bulk_sale_button.jsx